module.exports = __webpack_public_path__ + "img/1553850147.9486810e.jpg";